module.exports = __webpack_public_path__ + "static/media/challenge-3.34a4eea7.jpg";